import { analytics, auth } from "../firebase/firebase";

export default function (eventName, data = {}, beforeUserLogIn = false) {
  
  if(beforeUserLogIn){
    analytics.logEvent(eventName, data);
    return;
  }

  if(!auth.currentUser) return;

  analytics.logEvent(eventName,  {
    ...data,
    userAuthUid: auth.currentUser.uid
  });
}